import styles from "./Header.module.scss";
import Link from "next/link";
import Image from "next/image";

export default function PageHeader(props) {
  const { src, title, subtitle, text, pretitle, link, buttonText, children } = props
  return (
    <div className={styles.header}>
      {src && (
        <div className={styles.image}>
          <Image
            src={src}
            alt="background-image"
            fill={true}
            sizes="100vw"
            placeholder='blur'
            blurDataURL='/grey-placeholder.jpg'
            style={{ objectFit: 'cover', objectPosition: 'center' }}
          />
        </div>
      )}
      <div className={styles.content}>
        {pretitle && <div className={styles.subtitle}>{pretitle}</div>}
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {text && <p className={styles.text}>{text}</p>}
        {link && (
          <Link href={link} className="button" data-type="primary" role="button">
            {buttonText}
          </Link>
        )}
        {children}
      </div>
    </div>
  );
}
